<form [formGroup]="form" (ngSubmit)="save()" class="price-agreement">
  <div class="jbm-modal-header">
    <jbm-crud-title [subject]="'financial.price-agreement'" [action]="action"></jbm-crud-title>
    <div class="toolbar float-end">
      <jbm-spinner [loading]="loading"></jbm-spinner>
      <div class="toolbar-spacer-1"></div>
      <jbm-help-button [class]="'light'" [helpTopicID]="0"></jbm-help-button>
      <div class="toolbar-spacer-1"></div>
      <jbm-cross-close-button (onClick)="cancel()"></jbm-cross-close-button>
    </div>
  </div>

  <div class="jbm-modal-body">
    <ngb-alert *ngIf="warning" [type]="'warning'" [dismissible]="false">{{warning}}</ngb-alert>

    <fieldset class="price-agreement-context mb-3">
      <legend>{{'log.subject'|translate}}</legend>
      <jbm-static-label
        [labelCaption]="subjectLabel"
        [value]="subjectId"
        labelClass="width-8">
      </jbm-static-label>
      <jbm-static-label
        [labelCaption]="productTypeLabel"
        [value]="product_id"
        labelClass="width-8">
      </jbm-static-label>
    </fieldset>

    <jbm-text-input
      [formControl]="formControls.description"
      [submitted]="isSubmitted"
      [id]="'description'"
      [maxlength]="125"
      [required]="true"
      labelCaption="{{'entity.description'|translate}}"
      labelClass="width-8"
      class="input-25 mb-3">
      <jbm-input-error [formControl]="formControls.description" [submitted]="isSubmitted">
        {{'entity.requiredfield'|translate}}
      </jbm-input-error>
    </jbm-text-input>

    <fieldset class="price-agreement-validity mb-3">
      <legend>{{'pricelist.validity'|translate}}</legend>
      <jbm-date-input
        [formControl]="formControls.valid_from"
        [submitted]="isSubmitted"
        [id]="'valid_from'"
        [maxlength]="10"
        [required]="true"
        labelCaption="{{'pricelist.valid-from'|translate}}"
        labelClass="width-8"
        class="input-8">
        <jbm-input-error [formControl]="formControls.valid_from" [submitted]="isSubmitted">
          <span *ngIf="formControls.valid_from.hasError('required')">{{'entity.requiredfield'|translate}}</span>
          <span *ngIf="formControls.valid_from.hasError('dateInvalid')">{{'entity.dateformat'|translate}}</span>
        </jbm-input-error>
      </jbm-date-input>
      <jbm-date-input
        [formControl]="formControls.valid_to"
        [submitted]="isSubmitted"
        [id]="'valid_to'"
        [maxlength]="10"
        labelCaption="{{'pricelist.valid-to'|translate}}"
        labelClass="width-8"
        class="input-8">
        <jbm-input-error [formControl]="formControls.valid_to" [submitted]="isSubmitted">
          <span *ngIf="formControls.valid_to.hasError('dateInvalid')">{{'entity.dateformat'|translate}}</span>
        </jbm-input-error>
      </jbm-date-input>
    </fieldset>

    <fieldset class="price-agreement-rule mb-3">
      <legend>{{'financial.price-structure'|translate}}</legend>
      <jbm-select
        [formControl]="formControls.price_calculation_type"
        [options]="calculationTypeOptions"
        [submitted]="isSubmitted"
        [id]="'price_calculation_type'"
        [insertLeadingOption]="true"
        [required]="true"
        labelCaption="Calculation"
        labelClass="width-8"
        class="input-18"
        (onChange)="calculationTypeChange()">
        <jbm-input-error [formControl]="formControls.price_calculation_type" [submitted]="isSubmitted">
          {{'entity.requiredfield'|translate}}
        </jbm-input-error>
      </jbm-select>

      <jbm-static-label
        *ngIf="requiresAdjustmentDirection"
        labelCaption="Current price"
        [value]="priceBeforeDisplay"
        labelClass="width-8">
      </jbm-static-label>

      <jbm-select
        *ngIf="requiresAdjustmentDirection"
        [formControl]="formControls.adjustment_direction"
        [options]="adjustmentDirectionOptions"
        [submitted]="isSubmitted"
        [id]="'adjustment_direction'"
        [insertLeadingOption]="true"
        [required]="true"
        labelCaption="Adjustment"
        labelClass="width-8"
        class="input-18">
        <jbm-input-error [formControl]="formControls.adjustment_direction" [submitted]="isSubmitted">
          {{'entity.requiredfield'|translate}}
        </jbm-input-error>
      </jbm-select>

      <jbm-float-input-group
        [formControl]="formControls.value"
        [submitted]="isSubmitted"
        [id]="'value'"
        [required]="true"
        [negativeAllowed]="false"
        [prepend]="valuePrepend"
        [append]="valueAppend"
        labelCaption="Value"
        labelClass="width-8"
        class="input-10">
        <jbm-input-error [formControl]="formControls.value" [submitted]="isSubmitted">
          <span *ngIf="formControls.value.hasError('priceInvalid')">{{'entity.priceformat'|translate}}</span>
        </jbm-input-error>
      </jbm-float-input-group>
    </fieldset>

    <jbm-check
      [formControl]="formControls.blocked"
      [submitted]="isSubmitted"
      [id]="'blocked'"
      labelCaption="{{'entity.blocked'|translate}}"
      labelClass="width-8">
    </jbm-check>
  </div>

  <div class="jbm-modal-footer">
    <div class="toolbar float-end">
      <jbm-save-button [subject]="'financial.price-agreement'|translate" (click)="save()"></jbm-save-button>
      <div class="toolbar-spacer-1"></div>
      <jbm-cancel-button context="light" (click)="cancel()"></jbm-cancel-button>
    </div>
  </div>
</form>

<jbm-toasts></jbm-toasts>
